import React, { useState } from 'react'
import { IQuestion } from '../../../classes/Question';
import { ISurvey } from '../../../classes/Survey';
import './ComparativeInformationChart.css';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import 'chart.js/auto'; //fix: Canvas is already in use. Chart with ID '0' must be destroyed before the canvas can be reused.
import { Line } from 'react-chartjs-2'
import { DimensionsChartConfig } from '../../../classes/ChartConfig';

interface Props {
    survey: ISurvey,
    //questions: IQuestion[],
    questions: any[],
    currentSurvey: IQuestion[],
    titleSurveyCurrent: string,
    dimension: string,
    currentSurveyId: string,
    isFilterOnly?: boolean,
    filter?: string,
    onFilterChange?: (filter: string) => void,
}
/***
 * 
 */
const ComparativeInformationChart = (props: Props) => {
    const filter = props.filter || 'week';

    const changeFilter = (event: any): void => {
        if (props.onFilterChange) {
            props.onFilterChange(event.target.value);
        }
    }
    
    const chartConfig = new DimensionsChartConfig(props.questions, props.currentSurvey, props.titleSurveyCurrent, props.dimension, filter, props.currentSurveyId);
    
    const { options, data } = chartConfig.createChartConfig();
    const value = 5.98;
    const textValue = 'Job Security';
    const color = value > 0.66 ? value > 0.33 ? "#6DAE43" : "#FDD835" : "#FB5523";
    
    // If isFilterOnly is true, only render the filter
    if (props.isFilterOnly) {
        return (
            <select name="" id="" onChange={changeFilter} style={{fontSize: '14px', padding: '4px 8px', width: '120px'}}>
                <option value="week">Weekly</option>
                <option value="month">Monthly</option>
            </select>
        );
    }
    
    // Otherwise render only the chart
    return (
        <>
            <div style={{width: '100%', height: '260px', position: 'relative'}}>
                <Line options={options} data={data} />
            </div>
        </>
    )
}
export { ComparativeInformationChart };